const topics = [
  { label: '顶流塌房', heat: '99万', tag: '爆', color: 'primary' },
  { label: '网红翻车', heat: '87万', tag: '热', color: 'primary' },
  { label: '明星恋情', heat: '76万', tag: '新', color: 'accent' },
  { label: '综艺翻车', heat: '65万', tag: '热', color: 'primary' },
  { label: '资本大瓜', heat: '58万', tag: '爆', color: 'primary' },
  { label: '品牌翻车', heat: '49万', tag: '热', color: 'primary' },
  { label: '影视剧争议', heat: '42万', tag: '新', color: 'accent' },
  { label: '音乐圈瓜', heat: '38万', tag: '新', color: 'accent' },
  { label: '体育圈八卦', heat: '31万', tag: '热', color: 'primary' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            全网吃瓜群众正在关注的焦点事件
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
            {topics.map((topic) => (
              <div
                key={topic.label}
                className="group flex items-center gap-3 p-3 md:p-4 bg-background-50 rounded-lg cursor-pointer hover:bg-background-50/80 transition-colors"
              >
                <div
                  className={`w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center flex-shrink-0 ${
                    topic.color === 'primary'
                      ? 'bg-primary-100 text-primary-600'
                      : 'bg-accent-100 text-accent-600'
                  }`}
                >
                  <i className="ri-hashtag text-lg"></i>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1.5">
                    <h3 className="text-sm font-medium text-foreground-900 truncate">{topic.label}</h3>
                    <span
                      className={`text-[10px] px-1.5 py-0.5 rounded font-bold whitespace-nowrap ${
                        topic.tag === '爆'
                          ? 'bg-primary-500 text-white'
                          : topic.tag === '热'
                          ? 'bg-primary-100 text-primary-700'
                          : 'bg-accent-100 text-accent-700'
                      }`}
                    >
                      {topic.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-0.5">{topic.heat} 讨论</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}